<div style="padding:16px;max-width:900px;display:grid;gap:16px;font-size:13.5px">
  <h2 style="margin:0;font-size:20px">Beállítások</h2>
  <app-ugyfelkor-beallitas alrendszer="ESZKOZ" (valtozott)="betolt()"></app-ugyfelkor-beallitas>

  <div *ngIf="!u" class="halvany">Válassz céget a fejlécben a cégre szóló beállításokhoz.</div>
  <div *ngIf="hibaSz" style="color:#b42318">{{ hibaSz }}</div>

  <section *ngIf="b" style="border:1px solid #e4e7ec;border-radius:10px;padding:12px 14px;background:#fff;display:grid;gap:10px">
    <b>{{ eszkoz.aktiv.ugyfelNev }}</b>
    <div style="color:#667085">Adózási rend: <b>{{ b.adozas_rend_nev }}</b><span *ngIf="b.jogszabaly"> · {{ b.jogszabaly }}</span>
      <span *ngIf="b.onallo"> · önálló mód: nincs főkönyvi feladás, csak nyilvántartás</span></div>
    <label style="display:grid;gap:4px;max-width:320px">Értékcsökkenés elszámolása
      <select [(ngModel)]="b.ecs_gyakorisag" style="font:inherit;padding:6px 8px">
        <option value="havi">havonta</option><option value="negyedeves">negyedévente</option></select></label>
    <label style="display:grid;gap:4px;max-width:320px">Kis értékű eszköz értékhatára (Ft)
      <input type="number" [(ngModel)]="hatar" [disabled]="!b.onallo" style="font:inherit;padding:6px 8px"></label>
    <small class="halvany" *ngIf="!b.onallo">Kapcsolt módban az értékhatár a Könyvelés kettős könyvviteli beállításaiból jön – ott módosítható.</small>
    <div style="display:flex;gap:10px;align-items:center">
      <button type="button" (click)="ment()" [disabled]="fut" style="border:0;border-radius:6px;padding:7px 16px;font-weight:600;background:var(--naplo,#4338ca);color:#fff;cursor:pointer">Mentés</button>
      <span style="color:#05603a" *ngIf="uzenet">{{ uzenet }}</span>
    </div>
  </section>
</div>
